var filterBtns = document.querySelectorAll('[data-target]');
var filterTargets = document.querySelectorAll('[data-location]');

function setBtnState(btn) {
  var state = btn.getAttribute('aria-selected');

  if (state === 'true') {
    state = false;
  } else {
    state = true;
  }

  filterBtns.forEach(function (item) {
    item.setAttribute('aria-selected', 'false');
  });
  btn.setAttribute('aria-selected', state);
}

function filterItems(btn) {
  var btnVal = btn.getAttribute('data-target');
  filterTargets.forEach(function (target) {
    var targetVal = target.getAttribute('data-location');

    if (btnVal === 'all' || btnVal === targetVal) {
      target.setAttribute('aria-hidden', false);
    } else {
      target.setAttribute('aria-hidden', true);
    }
  });
  setBtnState(btn);
}

filterBtns.forEach(function (btn) {
  btn.addEventListener('click', function () {
    filterItems(btn);
  });
});